var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[(_vm.showAsNew)?_c('div',{staticClass:"w-8 h-8 background-primary margin-l-n4 margin-r-2 border-radius-round"}):_vm._e(),_vm._v(" "+_vm._s(_vm.quoteId)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }